import { Component, OnInit } from '@angular/core';
import { CategoryService } from '../services/category.service';
import { Category } from '../models/category-model';


@Component({
  selector: 'app-category-list',
  templateUrl: './category-list.component.html'
})
export class CategoryListComponent implements OnInit {
  categories: Category[] = [];
  loading = true;

  constructor(private categoryService: CategoryService) { }

  ngOnInit(): void {
    //this.loadCategories();
    this.loadCategoriesTree();
  }

  loadCategories(): void {
    this.loading = true;
    this.categoryService.getCategories().subscribe({
      next: (res: any) => {
        this.categories = res.items;
        this.loading = false;
      },
      error: () => (this.loading = false)
    });
  }

  loadCategoriesTree(): void {
    this.loading = true;
    this.categoryService.getTree().subscribe({
      next: (res: any) => {
        this.categories = res.items;
        this.loading = false;
      },
      error: () => (this.loading = false)
    });
  }

  deleteCategory(id: number) {
    if (confirm('Are you sure you want to delete this category?')) {
      this.categoryService.deleteCategory(id).subscribe(() => this.loadCategories());
    }
  }
}
